export class PlayScoreValue {
  constructor(public readonly charScore: number, public readonly completeWordScore: number) {}

  getTotalScore() {
    return this.charScore + this.completeWordScore;
  }
}
